<template>
  <v-list class="sf-nav"
          nav>

    <v-list-item exact
                 v-bind:to="{ name: 'administration-dashboard' }">
      <v-list-item-icon>
        <v-icon>ti-layout-dashboard</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('dashboard') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!--<v-list-item exact
                 v-bind:to="{ name: 'administration-company' }">
      <v-list-item-icon>
        <v-icon>ti-building</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('company') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>-->

    <v-list-item v-bind:to="{ name: 'administration-suppliers' }">
      <v-list-item-icon>
        <v-icon>ti-truck</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('suppliers') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-floor-plan' }">
      <v-list-item-icon>
        <v-icon>ti-map-2</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('floorPlan') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-info-documents' }">
      <v-list-item-icon>
        <v-icon>ti-file-type-pdf</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('infoDocuments') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-customers' }">
      <v-list-item-icon>
        <v-icon>ti-building-store</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('customers') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-custom-email-templates' }">
      <v-list-item-icon>
        <v-icon>ti-mail</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('customEmailTemplates') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-email-jobs' }">
      <v-list-item-icon>
        <v-icon>ti-mail-check</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('emailJobs') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-order-analytics' }">
      <v-list-item-icon>
        <v-icon>ti-chart-line</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('orderAnalytics') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-attendance' }">
      <v-list-item-icon>
        <v-icon>ti-ticket</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('attendance') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'administration-import' }">
      <v-list-item-icon>
        <v-icon>ti-database-import</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('import') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="sf-nav__divider" />

    <v-list-item exact
                 v-bind:to="{ name: 'home' }">
      <v-list-item-icon>
        <v-icon>ti-arrow-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('back') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  export default {
    name: 'AdministrationNavigation'
  }
</script>

<i18n>
  {
    "de": {
      "administration": "Administration",
      "back": "Zurück zur Web-App",
      "company": "Unternehmen",
      "customers": "Kunden",
      "dashboard": "Dashboard",
      "orderAnalytics": "Bestellanalyse",
      "suppliers": "Lieferanten",
      "floorPlan": "Lageplan",
      "infoDocuments": "Vorabinformationen",
      "attendance": "Einlass",
      "import": "Datenimport",
      "customEmailTemplates": "E-Mail-Vorlagen",
      "emailJobs": "Versandprotokoll"
    },
    "en": {
      "administration": "Administration",
      "back": "Back to the web app",
      "company": "Company",
      "customers": "Customers",
      "dashboard": "Dashboard",
      "orderAnalytics": "Order analytics",
      "suppliers": "Suppliers",
      "floorPlan": "Floor plan",
      "infoDocuments": "Preliminary information",
      "attendance": "Attendance",
      "import": "Import",
      "customEmailTemplates": "Custom email templates",
      "emailJobs": "Email log"
    }
  }
</i18n>
